import React, {Component} from 'react';
import { Line } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getJobProviderAnalysisAction } from '../../../actions/home';

var data = {
  labels: [],
  datasets: [
    {
      label: 'Received Resume',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: []
    }
  ]
};

class ReceivedResumeAnalysis extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchBiggestGainersArr: true,
            resumeCountRecivied:0,
            graphLabel:[],
            graphData:[]
        };
    }

    componentDidMount() {
        this.props.getJobProviderAnalysisAction();
    }

    componentWillReceiveProps(nextProps) {
 
         if(nextProps.responseGrpah&&nextProps.responseGrpah.statusCode===200 && nextProps.responseGrpah.resumeData.data ){
            var reciveData = nextProps.responseGrpah.resumeData.data;
            var today = new Date();
            var dd = today.getDate();
            var graphLabel = this.state.graphLabel;
                 graphLabel = [];
            var graphData=this.state.graphData;
                 graphData=[];
            for (let x=dd-6; x<=dd; x++){

                  let index = reciveData.findIndex(p => p._id.day === x)
                if(index===-1){
                    graphLabel.push(JSON.stringify(x))
                    graphData.push(0)
                }else if(index >-1){
                    graphLabel.push(JSON.stringify(x))
                    graphData.push(reciveData[index].count)
                }
            }
            data.labels=graphLabel;
            data.datasets[0].data=graphData;
            this.setState({
                graphLabel:graphLabel,
                graphData : graphData
            })
        }
    }

  render() {
    return (
      <div>
        <h2 className="graph-title">Weekly Analysis</h2>
        <Line ref="chart" data={data} />
      </div>
    );
  }
}


function mapStateToProps(state) {
    return {
       responseGrpah: state.home.responseGrpah
    };
}

export default withRouter(connect(mapStateToProps, {
  getJobProviderAnalysisAction
})(ReceivedResumeAnalysis))


// WEBPACK FOOTER //
// ./src/components/JobProvider/Graph/ReceivedResumeAnalysis.js